import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SandboxBanner from '../components/SandboxBanner';

/**
 * The operations terminal's header (PRD-MVP section 2): what a member of staff or a driver sees instead of the full
 * menu. A big way back to Today from any screen, who is signed in, and sign out. No settings, no menus of screens they
 * cannot use, nothing about money. Only their own account (password, two-step sign-in) is linked. The sandbox banner stays, as on every screen of a sandbox organisation.
 */
export default function TerminalBar({ user, brandName, onSignOut }) {
  const { pathname } = useLocation();
  const atToday = pathname === '/today';
  return (
    <nav className="bg-surface border-b border-surface-border sticky top-0 z-40" data-testid="terminal-bar">
      {user && <SandboxBanner />}
      <div className="max-w-5xl mx-auto px-4 flex items-center justify-between h-16 gap-3">
        <div className="flex items-center gap-3">
          <span className="font-semibold text-ink" data-testid="terminal-brand">{brandName || 'FoodOps'}</span>
          {!atToday && (
            <Link to="/today" data-testid="terminal-today"
                  className="rounded-xl bg-primary-500 text-white px-4 py-2 min-h-[44px] flex items-center font-medium">
              ← Today
            </Link>
          )}
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-ink-muted hidden sm:inline" data-testid="terminal-user">{user?.name || user?.email}</span>
          {/* Their own password and two-step sign-in: the one setting every member keeps. */}
          <Link to="/settings/security" data-testid="nav-settings-security" className="text-sm underline min-h-[44px] flex items-center">
            Account
          </Link>
          <button type="button" onClick={onSignOut} data-testid="terminal-sign-out"
                  className="border border-surface-border rounded-xl px-4 py-2 min-h-[44px] text-ink hover:bg-primary-50 focus-visible:outline-primary-500">Sign out</button>
        </div>
      </div>
    </nav>
  );
}
